<div class="container">
  <app-search
    [placeholder]="'Pesquise por uma turma'"
    (search)="handleSearch($event)"
  ></app-search>
  <mat-selection-list>
    <mat-checkbox
      class="all-select-checkbox"
      labelPosition="after"
      [checked]="allSelected"
      (change)="selectAllClicked()"
      [indeterminate]="listPartiallySelected()"
    >
      Todos os segmentos
    </mat-checkbox>
    <mat-divider></mat-divider>
    <div class="scrollable-area">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          matTreeNodeToggle
          [style.display]="!node.visible ? 'none' : ''"
        >
          <mat-checkbox
            class="checklist-leaf-node"
            labelPosition="after"
            [checked]="checklistSelection.isSelected(node)"
            (change)="todoLeafItemSelectionToggle(node)"
          >
            {{ node.name }}
          </mat-checkbox>
        </mat-tree-node>
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
        >
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name"
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? "expand_less" : "expand_more" }}
            </mat-icon>
          </button>
          <mat-checkbox
            labelPosition="after"
            [checked]="descendantsAllSelected(node)"
            [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)"
          >
            {{ node.name }}
          </mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
  </mat-selection-list>
  <mat-divider></mat-divider>
  <div class="buttons" *ngIf="!hideButtons">
    <button class="btn-reset" mat-button (click)="resetSelection()">
      Limpar
    </button>
    <button class="btn-apply" mat-raised-button (click)="applySelection()">
      Aplicar
    </button>
  </div>
</div>
